interface EditState {
  isEditing: boolean
  save: boolean
}

interface GraphRootState {
  graph?: {
    edit?: EditState
  }
}

const defaultEditState: EditState = {
  isEditing: false,
  save: false,
}


const selectEditing = (state: Record<string, unknown>): EditState => {
  const graph = (state as GraphRootState).graph
  return graph?.edit ?? defaultEditState
}

export default selectEditing
